import { render } from "./HeaderSidebarNew.vue?vue&type=template&id=20321650&scoped=true"
import script from "./HeaderSidebarNew.vue?vue&type=script&lang=js"
export * from "./HeaderSidebarNew.vue?vue&type=script&lang=js"

import "./HeaderSidebarNew.vue?vue&type=style&index=0&id=20321650&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2045206811/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20321650"]])

export default __exports__